import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

const lucaReq = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

async function loginLuca(username, password, customerNumber) {
    return await lucaReq.post(`${BASE_URL}/luca/login`, {
        username,
        password,
        customerNo: customerNumber
    });
}

async function getCompanyAndPeriodList(jSessionId, wMonId) {
    return await lucaReq.post(`${BASE_URL}/luca/companyAndPeriodList`, { jSessionId, wMonId });
}

async function getReceiptListAndDetails(jSessionId, wMonId, companyId, periodId, startDate, endDate, belgeTurleri) {
    return await lucaReq.post(`${BASE_URL}/luca/receiptListAndDetails`, { jSessionId: jSessionId, wMonId: wMonId, companyId, periodId, startDate, endDate, belgeTurleri });
}

async function sendReceiptsOnLuca(data) {
    return await lucaReq.post(`${BASE_URL}/luca/sendReceipt`, data);
}

async function sendReceiptEnvanter(data) {
    return await lucaReq.post(`${BASE_URL}/luca/sendReceiptEnvanter`, data);
}

async function sendCaptcha(data) {
    return await lucaReq.post(`${BASE_URL}/luca/captchaControl`, data);
}

async function getLucaPeriodList(jSessionId, wMonId, companyId) {
    return await lucaReq.post(`${BASE_URL}/luca/periodList`, { jSessionId, wMonId, companyId });
}

async function getLucaInventoryPeriodList(jSessionId, wMonId, periodId, customerId) {
    return await lucaReq.post(`${BASE_URL}/luca/envanterDonemListesi`, { jSessionId, wMonId, periodId, customerId });
}

async function getLucaInventoryPeriodDetail(jSessionId, wMonId, periodId, companyId, id) {
    return await lucaReq.post(`${BASE_URL}/luca/envanterDonemi`, { jSessionId, wMonId, periodId, companyId, id });
}

class LucaRequest {
    static async login(username, password, customerNumber) {
        try {
            const response = await lucaReq.post(`${BASE_URL}/luca/login`, {
                username,
                password,
                customerNo: customerNumber
            });

            this.jSessionId = response.data.data.jSessionId;
            this.wMonId = response.data.data.wMonId;

            const companyAndPeriodList = await this.getCompanyAndPeriodList(this.jSessionId, this.wMonId);

            return companyAndPeriodList;
        } catch (error) {
            return error;
        }
    }

    static async getCompanyAndPeriodList(jSessionId, wMonId) {
        try {
            const response = await lucaReq.post(`${BASE_URL}/luca/companyAndPeriodList`, { jSessionId, wMonId });
            return response.data.data;
        } catch (error) {
            return error;
        }
    }
}

export { loginLuca, getCompanyAndPeriodList, LucaRequest, getReceiptListAndDetails, sendReceiptsOnLuca, sendReceiptEnvanter, sendCaptcha, getLucaPeriodList, getLucaInventoryPeriodList, getLucaInventoryPeriodDetail };
